const ExportIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8794 3.16758H12.0388C11.9732 3.16758 11.9185 
    3.11289 11.9185 3.04727V2.08164H2.07944V11.9223H11.9201V10.9566C11.9201 
    10.891 11.9748 10.8363 12.0404 10.8363H12.881C12.9466 10.8363 13.0013 
    10.8895 13.0013 10.9566V12.5223C13.0013 12.7879 12.7873 13.002 12.5216 
    13.002H1.47944C1.21382 13.002 0.999756 12.7879 0.999756 
    12.5223V1.48164C0.999756 1.21601 1.21382 1.00195 1.47944 
    1.00195H12.5201C12.7857 1.00195 12.9998 1.21601 12.9998 
    1.48164V3.04727C12.9998 3.11445 12.9451 3.16758 12.8794 3.16758ZM13.1701 
    7.10039L10.9529 8.85039C10.8701 8.91602 10.7498 8.85664 10.7498 
    8.75195V7.56445H5.84351C5.77476 7.56445 5.71851 7.5082 5.71851 
    7.43945V6.56445C5.71851 6.4957 5.77476 6.43945 5.84351 
    6.43945H10.7498V5.25195C10.7498 5.14726 10.8716 5.08789 10.9529 
    5.15351L13.1701 6.90351C13.185 6.91521 13.1971 6.93015 13.2054 6.9472C13.2137 
    6.96426 13.218 6.98298 13.218 7.00195C13.218 7.02092 13.2137 7.03965 13.2054 
    7.0567C13.1971 7.07376 13.185 7.0887 13.1701 7.10039Z"
      fill="black"
      fillOpacity="0.65"
    />
  </svg>
);

export default ExportIcon;
